import React, { Component } from 'react';
import { connect } from 'react-redux';
import Formsy from 'formsy-react';
import { addPrinterByApi, updatePrinterByApi, closePrinterModal } from '../printer.actions';
import translator from '../../../components/localization/translator';
import { Modal } from 'react-bootstrap';
import { PRINTER_FIELDS } from './EditableFields';
import FooterButtons from '../../../components/common/elements/FooterButtons';
import FormInput from '../../../components/common/elements/FormInput';
import AutocompleteInput from '../../../components/common/elements/AutocompleteInput';
import CheckboxGroup from '../../../components/common/elements/CheckboxGroup';

class PrinterDetails extends Component {
    constructor(props) {
        super(props);
        this.changedData = {};
        this.state = {};
        this.cancel = this.cancel.bind(this);
        this.save = this.save.bind(this);
        this.setChangedData = this.setChangedData.bind(this);
		this.enableButton = this.enableButton.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.renderEditableFields = this.renderEditableFields.bind(this);
    }

    setChangedData(key, value) {
        this.changedData[key] = value;
    }

    getPrinterData() {
        const selectedPrinter = this.props.printers.selectedPrinter || {};
        const printer = {};
        PRINTER_FIELDS.forEach(field =>{
             printer[field.name] = selectedPrinter[field.name];
             if(this.changedData.hasOwnProperty) {
                printer[field.name] = this.changedData[field.name];
             }
        });
        return printer;
    }

    save() {
        const printer = this.getPrinterData();
        if(this.props.printers.selectedPrinter && this.props.printers.selectedPrinter._id) {
            this.props.updatePrinterByApi(this.props.printers.selectedPrinter._id, printer);
        } else {
            this.props.addPrinterByApi(printer);
        }
        this.cancel();
    }

    cancel() {
        this.props.closePrinterModal();
        this.setState({});
        this.changedData = {};
    }

    renderFooter() {
		return (
			<Modal.Footer>
				<FooterButtons
					cancelButton={translator.translate("_cancel_")}
					saveButton={translator.translate("_save_")}
					save={this.save}
					cancel={this.cancel}
                    isDisabled={this.state.isDisabled}
                    />
			</Modal.Footer>
		);
    }

    renderBoolean(options, index) {
        const selectedPrinter = this.props.printers.selectedPrinter || {};
        let checked = selectedPrinter.active || false;
        if('boolean'===  typeof this.state[options.name]) {
            checked = this.state[options.name];
        }
        return (
			<div className='display-flex' key={index}>
				<label className={`label-width`}>{translator.translate('_active_')}:</label>
				<div className='my-custom-input margin-to-left'>
                    <CheckboxGroup
                        id='active'
                        checked={checked}
                        onChange={(e) => {
                            this.setState({[options.name]: e.target.checked});
                            this.setChangedData(options.name, e.target.checked);
                        }}
                        customClass='margin-to-right'
                        customCheckboxClass='to-right' />
				</div>
			</div>
        );
    }

    renderAutocomplete(items, value, onChange, option) {
		return (<div key={option.key} className='display-flex '>
            <label className={'label-width'}>{ translator.translate(option.label)}</label>
            <div className='my-custom-input margin-to-left'>
                <AutocompleteInput
                    inputProps={{className: 'input-width'}}
                    items={items}
                    value={value || ''}
                    onChange={onChange}
                />
                {!value && option.required && <span className={'validation-error red-color'}>{translator.translate('_choose_autocomplete_')}</span>}
            </div>
        </div>);
    }

    getSelectedPartner() {
        const selectedPrinter = this.props.printers.selectedPrinter || {};
        const partnerId = this.changedData.partner || selectedPrinter.partner;
        return this.props.restaurants.find(restaurant => restaurant._id === partnerId) || {};
    }

    getSelectedBranch() {
        let branch = {};
        const selectedPrinter = this.props.printers.selectedPrinter || {};
        const partnerId = this.changedData.partner || selectedPrinter.partner;
        const branchId = this.changedData.branch || selectedPrinter.branch;
        const partner = this.props.restaurants.find(restaurant => restaurant._id === partnerId);
        if(partner && branchId) {
            branch = partner.branches.find(branch => branch._id === branchId);
        }
        return branch;
    }

    renderPartner(options, index) {
        const partner = this.getSelectedPartner();
        return this.renderAutocomplete(
            this.props.restaurants.filter(restaurant => !restaurant.deleted),
            partner.name,
            (list) => {
                if(list.length) {
                    const partner = list[0]._id;
                    this.setState({[options.name]: partner});
                    return this.setChangedData(options.name, partner);
                }
                this.setChangedData(options.name, '');
            },
            {key: index, label: '_partner_', required: options.required}
        );
    }

    renderBranch(options, index) {
        const partner = this.getSelectedPartner();
        const branchList = partner.branches ? partner.branches.filter(branch => !branch.deleted) : [];
        const branch = this.getSelectedBranch();
        return this.renderAutocomplete(
            branchList,
            branch.name,
            (list) => {
                if(list.length) {
                    const branch = list[0]._id;
                    this.setState({[options.name]: branch});
                    return this.setChangedData(options.name, branch);
                }
                this.setChangedData(options.name, '');
            },
            {key: index, label: '_branch_', required: options.required}
        );
    }

    renderEditableFields(options, index) {
        if ('boolean' === options.type) {
             return this.renderBoolean(options, index);
        }
        if ('partner' === options.name) {
             return this.renderPartner(options, index);
        }
        if ('branch' === options.name) {
            return this.renderBranch(options, index);
        }
        const selectedPrinter = this.props.printers.selectedPrinter || {};
        const value = this.changedData[options.name] || selectedPrinter[options.name] || '';
        return (
            <FormInput
				{...options}
				inputType={options.inputType}
				id={options.name}
                key={index}
				value={value}
				disabled={options.disabled}
				onChange={(e) => {
                    this.setState({[options.name]: e.target.value});
                    this.setChangedData(options.name, e.target.value)
				}}
            />
        );
    }

	disableButton() {
        this.setState({ isDisabled: true });
	}

	enableButton() {
		this.setState({ isDisabled: false });
	}

    render() {
        return (
            <Modal
                bsSize='large'
                show={this.props.printers.showModal}
                onHide={this.cancel.bind(this)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{(!this.props.printers.selectedPrinter || this.props.printers.selectedPrinter._id) && translator.translate('_create_new_printer_')}
						{(this.props.printers.selectedPrinter && this.props.printers.selectedPrinter._id) && translator.translate('_update_printer_')}
					</Modal.Title>
				</Modal.Header>
                <Modal.Body className="scrollable modal-possition">
                    <Formsy  onValid={this.enableButton} onInvalid={this.disableButton}>
                        {PRINTER_FIELDS.map(this.renderEditableFields)}
                    </Formsy>
				</Modal.Body>
                {this.renderFooter()}
			</Modal>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        printers: state.printers,
        restaurants: state.restaurants
    };
};
export default connect(mapStateToProps, {
    addPrinterByApi,
    updatePrinterByApi,
    closePrinterModal
})(PrinterDetails);
